import React from 'react';
import * as styles from './base.scss';
import classnames from 'classnames';
class AvailibilityCircle extends React.Component {
    render() {
        const { value } = this.props;
        const goodState = 'good';
        const neutralState = 'neutral';
        const badState = 'bad';
        return (React.createElement("span", { className: classnames(styles.availabilitycircle, { [styles.good]: value === goodState }, { [styles.neutral]: value === neutralState }, { [styles.bad]: value === badState }) }));
    }
}
export default AvailibilityCircle;
